<template>
  <div class="modal-content">
    <!-- Modal Header -->
    <div class="modal-header">
      <h6 class="modal-title">{{ $t("Contact Form") }}</h6>
      <button class="close" data-dismiss="modal" type="button">&times;</button>
    </div>

    <!-- Modal body -->
    <div class="modal-body">
      <div class="modal-in">
        <form @submit.prevent="submit">
          <fields
            :errors="errors"
            :fields="fields.all()"
            :model="model"
            layout="nolabel"
          />
        </form>
      </div>
    </div>
    <!-- Modal footer -->
    <div class="modal-footer">
      <button
        class="bordered-btn blue-button"
        type="button"
        @click.prevent="submit"
      >
        {{ $t("Send") }}
      </button>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "stylemix-base";

export default {
  name: "Register",

  mixins: [FormMixin],

  data() {
    return {
      model: {},
    };
  },

  created() {
    this.$http
      .get("companies/contact")
      .then((response) => {
        this.model = response.data.data;
        this.setFields(response.data.fields);
      })
      .then(() => {
        let keys = ["name", "phone", "email", "message"];
        keys.forEach((key) => {
          let field = this.fields.get(key);
          field.placeholder = this.$t(field.label);
        });
      });
  },
  mounted() {},

  methods: {
    submit() {
      this.errors.clear();
      this.$http
        .post(`companies/${this.$route.params.company_id}/contact`, this.model)
        .then((response) => {
          this.$toast.success(
            this.$t(
              "Thank you for contacting us. You will be reached out soon."
            )
          );
          this.closeForm();
        })
        .catch((rejection) => {
          this.$toast.error(this.$t("The given data was invalid"));
          if (rejection.response && rejection.response.status === 422) {
            this.setValidationErrors(rejection.response.data.errors);
          }
        });
    },
    closeForm() {
      $(".close").click();
    },
  },
};
</script>
